import { observer } from 'mobx-react-lite';

import { UPermissionsName } from '../../core/permissions';
import { useAccess } from '../use-access';

type CanAccessProps = {
  perm: UPermissionsName;
  children: JSX.Element | JSX.Element[];
  rejected?: JSX.Element | JSX.Element[];
};

export const CanAccess = observer(
  ({ perm, rejected, children }: CanAccessProps) => {
    const [hasAccess] = useAccess(perm);

    if (hasAccess) return <>{children}</>;
    if (rejected) return <>{rejected}</>;

    return null;
  }
);
